import { $t } from "./i18n";
import { BadRequest, ServerError, Unauthorized, Forbidden } from "@/api/errors";
import axios, { AxiosError } from "axios";
import Vue from "vue";
import store from "@/store/index";
import EventBus from "@/utils/EventBus";
import router from "@/router";
import {SnackbarMsgEvent} from "@/layout/Layout.vue";
// eslint-disable-next-line
Vue.config.errorHandler = async (error: any) => {
  if (error.from && error.to) {
    return;
  }
  let msg: string;
  if (error instanceof BadRequest) {
    msg = $t(error.details.message) as string;
  } else if (error instanceof Unauthorized) {
    msg = $t("Sitzung abgelaufen, Bitte loggen Sie sich erneut ein.") as string;
    store.commit("auth/failedCurrentUser");
    await store.dispatch("auth/resetCurrentUser");
    await router.push("/login");
  } else if (error instanceof ServerError) {
    msg = `${$t("Server-Fehler")}`;
  } else {
    msg = `${$t("Fehler")}: "${error.message ? error.message : error}"`;
    // eslint-disable-next-line no-console
    console.warn(error);
  }
  EventBus.$emit("snackbarInfosTo", {msg, severity: 2} as SnackbarMsgEvent);
};

axios.interceptors.response.use(undefined, async (error: AxiosError) => {
  const response = error.response;
  if (response) {
    if (response.status === 400) {
      throw new BadRequest({message: (response as any).data["message"] ?? "No Details"} );
    }
    if (response.status === 500 ) {
      throw new ServerError();
    }
    if (response.status === 401) {
      throw new Unauthorized();
    }
    if (response.status === 403) {
      throw new Forbidden();
    }
  }
  throw error;
});
